// import { compile } from 'path-to-regexp'
import { createResource } from '../../../../../redux/actions/resource'

export const sensorValues = createResource('sensor_values', {
  nesting: 'sensors/:sensorId',
})
export const sensors = createResource('sensors', {
  nesting: 'field_modules/:fieldModuleId',
})
